import {IMDMHierarchy, IMDMType} from "@retail-data-factory/rdf-angular-types-api";

export interface IMDMState {
  types: Array<IMDMType>;
  hierarchy: Array<IMDMHierarchy>;
  progress: number;
  isLoaded: boolean;
}

export const initialMDMState:IMDMState = {
  types: [],
  hierarchy: [],
  progress: 0,
  isLoaded: false
};
